export type NavLink = {
  label: string;
  to: string;
};

export const siteBrandName = 'ChatLP';

export const primaryNavLinks: NavLink[] = [
  { label: '機能', to: '/features' },
  { label: '料金', to: '/pricing' },
  { label: 'サンプル', to: '/cases' },
  { label: 'ヘルプ', to: '/help' },
];

export const ctaNavLink: NavLink = {
  label: 'ログイン',
  to: '/auth/sign-in',
};

export const footerMeta = {
  operatorName: '株式会社SILARIS',
  contactLabel: 'お問い合わせ：ヘルプ / お問い合わせ',
  contactTo: '/help#help-contact',
  copyrightName: '株式会社SILARIS',
};

export const legalFooterLinks = [
  { label: '運営会社', href: '/company' },
  { label: '利用規約', href: '/terms' },
  { label: 'プライバシーポリシー', href: '/privacy' },
];
